import moment from 'moment';

import { ACTIONS } from '@~/actions/teacher-chat-message';

const initialState = {
  eventType: null,
  eventData: {},
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SEND_TEACHER_CHAT_MESSAGE: {
      const { channel, message, meta } = payload;

      return {
        type,
        eventData: {
          meta,
          message,
          channel,
          event_time: Number(moment()),
        },
      };
    }
    default:
      return state;
  }
}
